import { useFilterStore } from './store';
import { filterRunningTrade } from './utils';

const useRunningTradeCustomFilter = (isUseCustomFilter: boolean) => {
  const getFilter = () => useFilterStore.getState().filter;
  const getStockFilter = () => useFilterStore.getState().stocksFilter;

  const runningTradeFilter = (items: RunningTradeItem[]) => {
    if (!isUseCustomFilter) return items;

    const filter = getFilter();
    const stockFilter = getStockFilter();

    return filterRunningTrade(items, filter, stockFilter);
  };

  return {
    runningTradeFilter,
  };
};

export default useRunningTradeCustomFilter;
